import styled, { css } from 'styled-components'
import { spacing_0_25, spacing_0_75, spacing_1, spacing_1_5, spacing_2 } from 'components/corpSite/components/theme/spacing'
import { h3_bold, body } from 'components/corpSite/components/theme/type-styles'
import { xsMd } from 'components/corpSite/components/theme/utils/media-query'
import { border_radius_1 } from 'components/corpSite/components/theme/border'
import { gray_6, primaryForSite } from 'components/corpSite/components/theme/colors'
import { proxima_nova } from 'components/corpSite/components/theme/font'
import { f_4 } from 'components/corpSite/components/theme/type-scale'

export function makeStats (element) {
  return styled(element)`
    font-family: ${proxima_nova};
    margin-right: ${ spacing_2 };
    margin-bottom: ${ spacing_2 };
    width: ${props => props.width || '164px'};
    text-align: ${props => props.align || 'center'};
    color: ${ gray_6 };
    p {
      ${body};
      margin-bottom: 0;
    }
    h2 {
      color: ${props => primaryForSite('careguide.com')};
      font-size: ${f_4};
    }
    h3 {
      ${h3_bold};
      margin: 0 ${spacing_1} ${spacing_0_25};
    }
    img {
      margin-bottom: ${ spacing_1_5 };
      border-radius: ${ border_radius_1 };
    }

    &:hover {
      text-decoration: none;
    }

    ${xsMd(css`
      margin-right: 0;
      width: 100%;
      max-width: 353px;

      &:last-child {
        margin-bottom: 0;
      }

      ${props => props.mobileRow && css`
        display: flex;
        flex-direction: row;
        max-width: 100%;
        justify-content: flex-start;
        align-items: flex-start;
        text-align: left;
        width: 100%;

        img {
          width: 80px;
          height: 80px;
          margin-right: ${ spacing_0_75 };
        }
      `}
    `)}
  `
}

export default makeStats
